import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/auth.store';
import { UserRole } from '../../types';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: UserRole | string;
  requiredRoles?: (UserRole | string)[];
  requireProvider?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredRole,
  requiredRoles,
  requireProvider,
}) => {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Check if user has ANY of the required roles
  const allowedRoles = requiredRoles || (requiredRole ? [requiredRole] : []);
  if (allowedRoles.length > 0) {
    const hasRequiredRole = allowedRoles.some(role =>
      user?.roles.includes(role as UserRole)
    );
    if (!hasRequiredRole) {
      return <Navigate to="/" replace />;
    }
  }

  if (requireProvider && !user?.isProvider) {
    return <Navigate to="/provider/onboarding" replace />;
  }

  return <>{children}</>;
};

